import React from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Divider } from 'antd';
import { FormattedNumber } from 'react-intl';
import {
  searchAndAddArticulo,
  borrarLinea,
  aplicarDescuento,
  modificarUnidades,
  borrarDescuento,
} from '../../../../state/actions/creators/encargos.creador.actioncreator';
import { Box, Flex, Text } from '../../../shared/components';
import ShowIf from '../../../shared/components/dataDisplay/ShowIf';
import SeleccionadorArticulo from '../../components/dataEntry/SeleccionarArticulo.dataentry';
import { obtenerEstadoRequestDesdeSaga } from '../../../../helpers/sagaStatus.helper';
import { encargoCreacionType } from '../../types/encargo.creacion.types';
import AgregadorDeArticulos from './AgregadorDeArticulos.dataentry';
import LineaArticulo from '../../components/dataDisplay/LineaArticulo.datadisplay';
import AddArticulosModal from '../../components/modal/AddArticulos.modal';
import BuscarPacienteModal from '../../components/modal/BuscarPaciente.modal';
import { obtenerDetallesSeparados } from '../../lib/busquedas.lib';
import {selectEncargoLinea} from "../../../../state/actions/creators/encargos.actioncreator";

class DetallesEncargo extends React.Component {
  constructor(props) {
    super(props);
    this.modalRef = React.createRef();
  }

  renderTotalEncargo(detalles) {
    let totalEncargo = 0;
    detalles.forEach(({ precio }) => {
      totalEncargo += precio;
    });
    return (
      <Flex justifyContent="space-between" bg="#FAFAFA" pt="16px" pb="16px" mr="-16px" ml="-16px" pr="16px" pl="16px">
        <Box>
          <Box mb="8px"><Text upperCase color="#777572" fontSize="12px" translationId="encargos.importe_encargo" /></Box>
          <Box mb="8px">
            <Text fontWeight="semibold" color="#3E3E3C" fontSize="16px">{detalles.length}</Text>
            {' '}
            <Text fontWeight="semibold" color="#3E3E3C" fontSize="16px" translationId="encargos.articulos" />
          </Box>
        </Box>
        <Box style={{ textAlign: 'right' }}>
          <Box mb="8px">
            <Text translationId="encargos.total" fontSize="14px" />
          </Box>
          <Box mb="8px"><Text fontWeight="semibold" color="#3E3E3C" fontSize="16px"><FormattedNumber minimumFractionDigits="2" maximumFractionDigits="2" style="currency" currency="EUR" value={totalEncargo} /></Text></Box>
          <Box mb="8px">
            <Button
              style={{
                margin: '0 0 0 0', padding: '0 0 0 0', border: '0', height: '16px', pointerEvents: 'none'
              }}
              type="link"
            >
              <Text fontSize="14px" translationId="encargos.descuento" />
            </Button>
          </Box>
        </Box>
      </Flex>
    );
  }

  renderHeaderConjunto(titulo, detalles) {
    let totalConjunto = 0;
    detalles.forEach(({ precio }) => {
      totalConjunto += precio;
    });
    return (
      <Flex justifyContent="space-between" mb="20px">
        <Box>
          <Box mb="8px" height="16px" />
          <Box><Text fontWeight="semibold" color="#3E3E3C" fontSize="16px">{titulo}</Text></Box>
        </Box>
        <Box style={{ textAlign: 'right' }}>
          <Box mb="8px">
            <Text translationId="encargos.subtotal" fontSize="14px" />
          </Box>
          <Box><Text fontWeight="semibold" color="#3E3E3C" fontSize="16px"><FormattedNumber minimumFractionDigits="2" maximumFractionDigits="2" style="currency" currency="EUR" value={totalConjunto} /></Text></Box>
        </Box>
      </Flex>
    );
  }

  renderDetalles(detalles, titulo) {
    if (detalles.length === 0) return null;
    const { borrarLinea, encargo: { uuid }, modo, selectEncargoLinea } = this.props;
    const componentes = detalles.map((detalle) => {
      const { linea } = detalle;
      return (
        <Box key={linea} mb="16">
          <LineaArticulo modo={modo} detalle={detalle} onSelectLinea={linea => selectEncargoLinea(linea)} onClickEliminarArticulo={() => borrarLinea({ encargoUUID: uuid, linea })} />
        </Box>
      );
    });
    return (
      <Box>
        {this.renderHeaderConjunto(titulo, detalles)}
        {componentes}
        <Divider style={{ margin: '0 0 0 0' }} dashed />
      </Box>
    );
  }

  render() {
    const {
      encargo, estadoPeticionBuscarArticulo, history, modo,
    } = this.props;
    const { running } = estadoPeticionBuscarArticulo;
    const { uuid } = encargo;
    const { detalles } = encargo;
    const sinDetalles = detalles.length === 0;
    const { detallesGafasGraduadas, detallesSinConjunto } = obtenerDetallesSeparados(detalles);
    return (
      <Box>
        <AddArticulosModal history={history} ref={this.modalRef} encargoUUID={uuid} linea={detalles.length + 1} />
        <Text upperCase fontSize="12" translationId="encargos.articulos" color="#777572" />
        { this.renderDetalles(detallesGafasGraduadas, 'Gafas graduadas') }
        { this.renderDetalles(detallesSinConjunto, 'Otros artículos') }
        <ShowIf condition={modo !== 'mostrar'}><AgregadorDeArticulos cargando={running} encargoUUID={uuid} onSeleccionarArticulos={() => this.modalRef.current.show()} /></ShowIf>
        <ShowIf condition={!sinDetalles}>
          <Divider style={{ margin: '16px 0 0 0' }} dashed />
          {this.renderTotalEncargo(detalles)}
          <Divider style={{ margin: '0 0 16px 0' }} dashed />
        </ShowIf>
      </Box>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    searchAndAddArticulo,
    borrarLinea,
    aplicarDescuento,
    modificarUnidades,
    borrarDescuento,
    selectEncargoLinea,
  }, dispatch);
}

const mapStateToProps = (state) => {
  const { sagas } = state;
  return {
    estadoPeticionBuscarArticulo: obtenerEstadoRequestDesdeSaga(sagas, 'ENCARGOS_CREACION_BUSCAR_Y_ESTABLECER_ARTICULO_A_LINEA'),
  };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(DetallesEncargo));

DetallesEncargo.propTypes = {
  borrarLinea: PropTypes.func.isRequired,
  encargo: encargoCreacionType.isRequired,
  estadoPeticionBuscarArticulo: PropTypes.shape({
    running: PropTypes.bool,
    success: PropTypes.bool,
  }).isRequired,
  history: PropTypes.any.isRequired,
  modo: PropTypes.string.isRequired,
  searchAndAddArticulo: PropTypes.func.isRequired,
  aplicarDescuento: PropTypes.func.isRequired,
  modificarUnidades: PropTypes.func.isRequired,
  borrarDescuento: PropTypes.func.isRequired,
};
